import { apiClient } from './client.js';

export const courseApi = {
  getCategories: () => apiClient.get('/courses/categories'),
  getCourses: (params) => apiClient.get('/courses', { params }),
  getCourseDetails: (idOrSlug) => apiClient.get(`/courses/${idOrSlug}`),
  createCourse: (data) => apiClient.post('/courses', data),
  updateCourse: (id, data) => apiClient.patch(`/courses/${id}`, data),
  deleteCourse: (id) => apiClient.delete(`/courses/${id}`),
};
